var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7317 18.1243H14.1463C14.1317 17.8531 14.0978 17.4367 14.0204 17.0009C13.7734 15.5967 13.1488 14.3474 12.2627 13.35C12.9551 13.0013 13.7298 12.8125 14.5336 12.8125C16.9886 12.8125 19.0852 14.575 19.5161 17.0009C19.6081 17.5287 19.2595 18.0274 18.7317 18.1243Z",
    fill: "#292929",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.534 11.8434C16.4059 11.8434 17.9235 10.3259 17.9235 8.45392C17.9235 6.58197 16.4059 5.06445 14.534 5.06445C12.662 5.06445 11.1445 6.58197 11.1445 8.45392C11.1445 10.3259 12.662 11.8434 14.534 11.8434Z",
    fill: "#292929",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78659 10.3915C9.19338 10.3915 11.1445 8.44045 11.1445 6.03366C11.1445 3.62687 9.19338 1.67578 6.78659 1.67578C4.3798 1.67578 2.42871 3.62687 2.42871 6.03366C2.42871 8.44045 4.3798 10.3915 6.78659 10.3915Z",
    fill: "#292929",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0674 17.1705C12.5197 14.0842 9.87887 11.8438 6.7872 11.8438C3.69553 11.8438 1.05465 14.0842 0.50701 17.1705C0.484843 17.2958 0.487562 17.4241 0.515012 17.5483C0.542461 17.6725 0.594103 17.7901 0.666989 17.8943C0.739875 17.9985 0.832577 18.0874 0.939802 18.1558C1.04703 18.2242 1.16667 18.2708 1.29191 18.2929H12.282C12.4073 18.2708 12.527 18.2243 12.6343 18.1559C12.7415 18.0875 12.8343 17.9987 12.9072 17.8944C12.9802 17.7902 13.0319 17.6726 13.0593 17.5484C13.0868 17.4242 13.0896 17.2958 13.0674 17.1705Z",
    fill: "#292929",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/Connection.fe36264efcf7016ab13d618ecee47181.svg";
export { ForwardRef as ReactComponent };